<template>
  <div class="w-100 h-100 p-relative pt-5">
    <div class="container container-uedahiraku">
      <div class="py-2 py-md-5">
      </div>
      <template v-if="!isMobile().phone">
        <div class="row">
          <div class="col-xl-11">
            <b-row no-gutters id="pastWorksCategoryRow">
              <b-col v-for="category in categories" :key="category.term_id" cols="3" lg="2" class="px-1 pb-2">
                <b-button class="px-1" :variant="selectedTermId == category.term_id? 'dark': 'outline-dark'" block @click="selectedTermId=category.term_id; getPastWorks()">
                  {{ category.name }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row v-if="pastWorks.length > 0" no-gutters class="mt-4">
          <b-col md="4" lg="3">
            <ul>
              <li v-for="pastwork in arrangePastWorks(0)" :key="pastwork.id">{{ pastwork.title.rendered }}</li>
            </ul>
          </b-col>
          <b-col md="4" lg="3">
            <ul>
              <li v-for="pastwork in arrangePastWorks(1)" :key="pastwork.id">{{ pastwork.title.rendered }}</li>
            </ul>
          </b-col>
          <b-col md="4" lg="3">
            <ul>
              <li v-for="pastwork in arrangePastWorks(2)" :key="pastwork.id">{{ pastwork.title.rendered }}</li>
            </ul>
          </b-col>
          <b-col class="d-none d-lg-block" md="4" lg="3">
            <ul>
              <li v-for="pastwork in arrangePastWorks(3)" :key="pastwork.id">{{ pastwork.title.rendered }}</li>
            </ul>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-dropdown id="dropdown-mobile"  no-caret variant="outline-dark" class="btn-block text-left">
          <template v-slot:button-content>
            <div class="d-flex justify-content-between align-items-center">
              {{selectedMobileText}}
              <font-awesome-icon icon="angle-down" />
            </div>
          </template>
          <b-dropdown-item v-for="category in categories" :key="'mobile-'+category.term_id" @click="selectedTermId=category.term_id; selectedMobileText = category.name; getPastWorks()">{{ category.name }}</b-dropdown-item>
        </b-dropdown>
        <div class="card border-top-0 border-dark card-scroll" :style="mobileCardStyle" v-if="pastWorks.length > 0">
          <div class="card-body pl-0">
            <ul>
              <li v-for="pastWork in pastWorks" :key="pastWork.id">
                {{pastWork.title.rendered}}
              </li>
            </ul>
          </div>
        </div>
      </template>

    </div><!-- /.container -->
    <h2 class="right-title futura tracking-1">PAST ART WORKS</h2>
    <div class="right-item">
      <div class="tategaki font-weight-bold">
        過去の作品たち
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from 'ismobilejs'
import { mapActions } from 'vuex'

export default {
  name: 'PastWorks',
  data() {
    return {
      isMobile,
      categories: [],
      selectedTermId: null,
      pastWorks: [],
      selectedMobileText: 'カテゴリ'
    }
  },
  mounted() {
    this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: false})
    this.getCategories()
  },
  computed: {
    mobileCardStyle() {
      return {height: window.innerHeight -170 + 'px'} 
    }
  },
  methods: {
    ...mapActions({
      setPageControl: 'doSetPageControl'
    }),
    async getCategories() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/uedahiraku/v1/past_works_category')
      .catch((e) => {
        console.log(e)
        this.categories = []
      });
      if (payload.data) {
        console.log(payload.data)
        this.categories = payload.data
        this.selectedTermId = this.categories[0].term_id
        this.selectedMobileText = this.categories[0].name
        this.getPastWorks()
      }
    },
    async getPastWorks() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/pastworks?per_page=100&past_works_category=' + this.selectedTermId)
      .catch((e) => {
        console.log(e)
        this.pastWorks = []
      });
      if (payload.data) {
        console.log(payload.data)
        this.pastWorks = payload.data
      } else {
        this.pastWorks = []
      }
    },
    arrangePastWorks(offset) {
      let range = window.innerHeight - 48*3 - 50
      range -= document.getElementById('pastWorksCategoryRow').clientHeight;
      if (this.isMobile().tablet) {
        range -= 35
      }
      range = Math.floor(range / 21)
      return this.pastWorks.slice(offset*range, offset*range+range)
    }
  }
}
</script>

<style lang="scss">
#dropdown-mobile {
  .btn-outline-dark {
    text-align: left !important;
  }
}
</style>

<style lang="scss" scoped>
.card-scroll {
  overflow: scroll;
  background-color: #fcfcfc;
}
</style>